/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    LOG_BANNER_CODE_TRIED,
    ATTRIBUTION_APPLY_PROMO,
    ATTRIBUTION_APPLY_PROMO_COMPLETED,
    ATTRIBUTION_APPLY_PROMO_LINKED_PAYMENTMETHOD,
    ATTRIBUTION_APPLY_PROMO_LINKED_PAYMENTMETHOD_COMPLETED,
} from './Attribution-ActionTypes';

export const logBannerCodeTried = (tried) => ({
    type: LOG_BANNER_CODE_TRIED,
    data: {
        tried,
    },
});

export const attributionApplyPromoLinkedPaymentMethod = (supportedPaymentMethods) => ({
    type: ATTRIBUTION_APPLY_PROMO_LINKED_PAYMENTMETHOD,
    data: {
        supportedPaymentMethods,
    },
});

export const attributionApplyPromoLinkedPaymentMethodCompleted = () => ({
    type: ATTRIBUTION_APPLY_PROMO_LINKED_PAYMENTMETHOD_COMPLETED,
});

export const attributionApplyPromo = () => ({
    type: ATTRIBUTION_APPLY_PROMO,
});

export const attributionApplyPromoCompleted = () => ({
    type: ATTRIBUTION_APPLY_PROMO_COMPLETED,
});

export default {};
